import { lazy } from "react";

// project imports
import MinimalLayout from "../layout/MinimalLayout";
import Loadable from "./../components/Loadable";

// auth routing
const AuthLogin = Loadable(lazy(() => import("../views/login")));
const PublicCustomerDetails = Loadable(
  lazy(() => import("../views/public-customer-details"))
);
const CustomersManage = Loadable(
  lazy(() => import("../views/customers/manage"))
);
// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: "/",
  element: <MinimalLayout />,
  children: [
    {
      path: "/login",
      element: <AuthLogin />,
    },
    {
      path: "/public-customer-details/:id",
      element: <PublicCustomerDetails />,
    },
    {
      path: "/public-customer-task/:task_id",
      element: <CustomersManage />,
    },
  ],
};

export default AuthenticationRoutes;
